import React from "react";
import { TrendingUp, TrendingDown, ArrowLeft } from "lucide-react";
import dayjs from "dayjs";

const WalletLogCard = ({ log }) => {
  // ✅ استخدام amount مباشرة من الـ API
  const amount = parseFloat(log.amount || 0);
  
  // ✅ تحديد نوع العملية: إذا الرصيد الحالي أكبر = إضافة (+)
  const isCredit = parseFloat(log.balance_after) > parseFloat(log.balance_before);
  
  // ✅ حساب النسبة المئوية
  const percentage = ((amount / parseFloat(log.balance_before || 1)) * 100).toFixed(1);

  // ✅ تحديد اللون حسب transaction_type
  const getConfig = () => {
    // الحالات الخاصة (pending = أصفر، cancel = أحمر)
    if (log.transaction_type === "order_pending") {
      return {
        bgColor: "bg-gray-900/50",
        borderColor: "border-gray-800/50 hover:border-yellow-500/30",
        iconBg: "bg-yellow-500/10",
        icon: <TrendingDown className="w-5 h-5 text-yellow-500" />,
        amountColor: "text-white",
        sign: isCredit ? "+" : "-",
        percentColor: "text-yellow-500",
        typeLabel: log.transaction_type_display || "معلق",
        typeBg: "bg-yellow-500/20",
        typeText: "text-yellow-400",
        balanceAfterColor: "text-white",
      };
    }

    if (log.transaction_type === "order_cancel") {
      return {
        bgColor: "bg-gray-900/50",
        borderColor: "border-gray-800/50 hover:border-red-500/30",
        iconBg: "bg-red-500/10",
        icon: <TrendingUp className="w-5 h-5 text-red-500" />,
        amountColor: "text-white",
        sign: isCredit ? "+" : "-",
        percentColor: "text-red-500",
        typeLabel: log.transaction_type_display || "ملغي",
        typeBg: "bg-red-500/20",
        typeText: "text-red-400",
        balanceAfterColor: "text-white",
      };
    }

    // الحالة العامة (حسب isCredit)
    if (isCredit) {
      return {
        bgColor: "bg-gray-900/50",
        borderColor: "border-gray-800/50 hover:border-green-500/30",
        iconBg: "bg-green-500/10",
        icon: <TrendingUp className="w-5 h-5 text-green-500" />,
        amountColor: "text-white",
        sign: "+",
        percentColor: "text-green-500",
        typeLabel: log.transaction_type_display || "إضافة",
        typeBg: "bg-green-500/20",
        typeText: "text-green-400",
        balanceAfterColor: "text-white",
      };
    } else {
      return {
        bgColor: "bg-gray-900/50",
        borderColor: "border-gray-800/50 hover:border-red-500/30",
        iconBg: "bg-red-500/10",
        icon: <TrendingDown className="w-5 h-5 text-red-500" />,
        amountColor: "text-white",
        sign: "-",
        percentColor: "text-red-500",
        typeLabel: log.transaction_type_display || "خصم",
        typeBg: "bg-red-500/20",
        typeText: "text-red-400",
        balanceAfterColor: "text-white",
      };
    }
  };

  const config = getConfig();

  return (
    <div
      className={`${config.bgColor} backdrop-blur-sm rounded-xl p-4 border ${config.borderColor} transition-all duration-300 hover:shadow-lg`}
      dir="rtl"
    >
      {/* ✅ Header - بالضبط زي الصورة */}
      <div className="flex items-start justify-between mb-3">
        {/* Right Side: Icon + Amount + Percentage + Type */}
        <div className="flex items-start gap-3 flex-1">
          <div className={`${config.iconBg} p-2.5 rounded-lg flex-shrink-0`}>
            {config.icon}
          </div>
          
          <div className="flex-1 min-w-0">
            {/* Amount + Percentage */}
            <div className={`${config.amountColor} font-bold text-base flex items-center gap-1.5 mb-1.5`}>
              <span className={config.percentColor}>
                ({percentage}%)
              </span>
              <span>
                {config.sign}${amount.toFixed(2)}
              </span>
            </div>
            
            {/* Type Badge */}
            <span className={`${config.typeBg} ${config.typeText} px-2.5 py-0.5 rounded-full text-xs inline-block`}>
              {config.typeLabel}
            </span>
          </div>
        </div>

        {/* Left Side: Transaction ID + Date */}
        <div className="text-left flex-shrink-0">
          <div className="text-sm text-gray-300 font-medium mb-1">
            {log.reference_id || log.transaction_id}
          </div>
          <div className="text-xs text-gray-500">
            {dayjs(log.created_at).format("HH:mm DD/MM/YYYY")}
          </div>
        </div>
      </div>

      {/* ✅ Description */}
      <div className="text-sm text-gray-300 mb-3 leading-relaxed">
        {log.description}
      </div>

      {/* ✅ Balance Change - السطر الأخير بالضبط زي الصورة */}
      <div className="flex items-center justify-between text-xs">
        {/* الرصيد السابق */}
        <div className="flex items-center gap-1.5">
          <span className="text-gray-400">الرصيد السابق:</span>
          <span className="text-white font-medium">
            ${parseFloat(log.balance_before).toFixed(2)}
          </span>
        </div>

        {/* Arrow */}
        <ArrowLeft className="w-3 h-3 text-gray-500 flex-shrink-0" />

        {/* الرصيد الجديد */}
        <div className="flex items-center gap-1.5">
          <span className="text-gray-400">الرصيد الجديد:</span>
          <span className={`${config.balanceAfterColor} font-medium`}>
            ${parseFloat(log.balance_after).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default WalletLogCard;